import SessionTokenService from '@/abstractions/SessionTokenService';

const SESSION_TOKEN_SERVICE = new SessionTokenService('accessToken');

export default SESSION_TOKEN_SERVICE;
